import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Card, CardContent, CardHeader, Stack, Button } from '@mui/material';


const Events = () => (
  <Card>
    <CardHeader title="Zapisy na zajęcia" />
    <CardContent>
      <Stack direction="row" spacing={4}>
        <Button style={{ color: 'white' }} variant="contained" component={RouterLink} to="/zapisy" target="_blank" fullWidth>
          zapisy
        </Button>
      </Stack>
    </CardContent>
  </Card>
);

export default Events;
